import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import cookies from "js-cookie";
import { LangaugeStyleWrapper } from "./languageSwitcher.style";
import { Button } from "primereact/button";
import { useParams } from "react-router-dom";
import { BUSINESS_LINE_COLORS, BUSINESS_LINE_PATHS } from "helpers/utils";

import ArLang from "../../assets/images/lead/language-arabic.svg";
import EnLang from "../../assets/images/lead/language-english.svg";

const languages = [
  {
    code: "ar",
    name: "Arabic",
    native: "عربى",
    dir: "rtl",
    country_code: "sa",
  },
  {
    code: "en",
    name: "English",
    native: "World Wide",
    country_code: "us",
    dir: "ltr",
  },
];



const LanguageSwitcherMobile = (props) => {
  const { i18n } = useTranslation();
  const currentLanguageCode = i18n.language;
  const currentLanguage = languages.find((lang) => lang.code === currentLanguageCode);

  useEffect(() => {
    document.body.dir = i18n.dir();
  }, [currentLanguage, i18n]);

  const changeLanguage = lang => i18n.changeLanguage(lang);

  return (
    <LangaugeStyleWrapper>
      <>
        {
          i18n.language === 'ar'? 
            <div className="ar btn" onClick={()=>changeLanguage('en')}>
              <img src={ArLang} alt="" />
            </div>
          :
            <div className="en btn" onClick={()=>changeLanguage('ar')}>
              <img src={EnLang} alt="" />
            </div>

        }
      </>
      
    </LangaugeStyleWrapper>
  );
};

export default LanguageSwitcherMobile;
